/**
 * Utility functions for validation rules handling
 */

/**
 * Removes required rules from a validation rules string while preserving compound rules like required_boolean
 *
 * @param rules - The original rules string (e.g., "required|email" or "required_boolean|custom")
 * @returns The rules string without the required rules
 *
 * Examples:
 * - "required" → ""
 * - "required|email" → "email"
 * - "email|required" → "email"
 * - "required_boolean" → "required_boolean" (preserved)
 * - "required_boolean|custom" → "custom"
 */
export function removeRequiredRules(rules: string): string {
  if (!rules) return ""

  return rules
    .toString()
    .replace("required_boolean|", "")
    .replace("|required_boolean", "")
    .replace("required_boolean", "")
    .replace("required|", "")
    .replace("|required", "")
    .replace("required", "")
}

/**
 * Filters validation rules based on validation activation status
 * When validation is disabled, removes "required" and "required_*" rules
 *
 * @param rules - The original rules string or array
 * @param validationActivated - Whether validation is currently active
 * @returns The filtered rules string
 */
export function filterRulesByValidationStatus(
  rules: string | string[] | unknown[] | undefined,
  validationActivated: boolean,
): string {
  if (!rules) return ""

  const rulesStr = rules.toString()

  if (!validationActivated) {
    return removeRequiredRules(rulesStr)
  }

  return rulesStr
}
